import Link from "next/link";
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { IFontProps, IProductType } from "@/typings/Props";
import { media } from "@/styles/media";

export default function ProductItem(props: IProductType) {
  const { t } = useTranslation();
  return (
    <ItemWrapper className="item-wrapper" href={`/product/${props.link}`}>
      <ImgWrapper>
        <Img className="detail_img" src={props.hoverImage} alt="product_detail_image" />
        <Img className="img" src={props.mainImage} alt="product_image" />
      </ImgWrapper>
      <DescWrapper>
        <P $fontSize="1.75rem" $fontColor="#444">
          {t(props.title)}
        </P>
        <P className="desc" $fontSize="1rem" $fontColor="#676767">
          {t(props.description)}
        </P>
      </DescWrapper>
    </ItemWrapper>
  );
}

const ItemWrapper = styled(Link)`
  width: calc(20% - 15px);
  height: auto;
  aspect-ratio: 1/1.1;
  border: none;
  border-radius: 10px;
  background-color: #ffffff;
  transition: 0.3s ease-out;
  cursor: pointer;

  ${media.largeDesktop`
    width: calc(25% - 15px);
    aspect-ratio: 1/1;
  `}
  ${media.tablet`
    width: calc(50% - 10px);
  `}

  @media (min-width: 1000px) {
    &:hover {
      transform: scale(1.1, 1.1);
      transition: 0.3s ease-out;
      z-index: 999;
      box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.03);
    }
    &:hover > div > .img {
      transition: 0.2s ease-out;
      opacity: 0;
    }
    &:hover > div > .detail_img {
      transform: scale(0.9, 0.9);
      transition: 0.3s ease-out;
      opacity: 1;
    }
  }
`;

const DescWrapper = styled.div`
  width: 100%;
  height: 146px;
  padding: 25px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${media.tablet`
    height: auto;
    margin-top: 20px;
    margin-bottom: 20px;
    & .desc {
      display: none;
    }
  `}
`;

const ImgWrapper = styled.div`
  position: relative;
  width: 100%;
  height: calc(100% - 30px);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;

  ${media.tablet`
    height: 100%;
  `}
`;

const Img = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  transition: 0.2s ease-out;
  object-fit: cover;
`;

const P = styled.p<IFontProps>`
  font-size: ${(props) => props.$fontSize};
  color: ${(props) => props.$fontColor};

  &.desc {
    line-height: 16px;
    white-space: pre-line;
  }

  ${media.tablet`
    padding: 10px 0;
    text-align: left;
  `}
`;
